import { SimpleCommentsStructure } from 'structure/simple-comments';
import { demoFile, feature } from 'system/demo';

import { AccountPushNotificationPermissionFeature } from '../account-push-notification-permission';

demoFile('open-modules/zdf/feature/account/account-push-notification-permission');

feature('Push Notification Permission', {
    structureKey: 'simplecomments',
    config: SimpleCommentsStructure.receivesConfigDefaults,
    features: { notificationpermission: true, pushnotificationpermission: true },
});
